import {
  APP_HEADER_HEIGHT,
  APP_HEADER_HEIGHT_MOBILE,
  COLOR_PALETTE,
  mediaQuery,
} from 'constants/ui';

export const drawerStyles = {
  top: `${APP_HEADER_HEIGHT}px`,

  [mediaQuery.mobileAndTablet]: {
    top: `${APP_HEADER_HEIGHT_MOBILE}px`,
  },
};

export const backdropStyles = {
  top: `${APP_HEADER_HEIGHT}px`,

  [mediaQuery.mobileAndTablet]: {
    top: `${APP_HEADER_HEIGHT_MOBILE}px`,
  },
};

export const wrapperStyles = {
  height: `calc(100% - ${APP_HEADER_HEIGHT}px)`,
  width: '30%',
  top: `${APP_HEADER_HEIGHT}px`,

  [mediaQuery.mobile]: {
    width: '75%',
  },

  [mediaQuery.mobileAndTablet]: {
    height: `calc(100% - ${APP_HEADER_HEIGHT_MOBILE}px)`,
    top: `${APP_HEADER_HEIGHT_MOBILE}px`,
  },
};

export const contentBlockStyles = {
  padding: '8px 12px',
};

export const themeRowStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
  padding: '12px 16px',
};

export const flatMenuButtonStyles = {
  padding: '12px 16px',
  height: 'unset',
  minWidth: '100%',
  width: 'fit-content',
  justifyContent: 'flex-start',

  font: ({ typography }) => typography.medium16,
  color: ({ palette }) => `${palette.text.dark} !important`,
  backgroundColor: 'transparent !important',
  borderRadius: '8px',
  textDecoration: 'none !important',
  cursor: 'pointer',

  '&:hover': {
    color: ({ palette }) => `${palette.text.link} !important`,
    backgroundColor: `${COLOR_PALETTE.BRAND[1]} !important`,
  },
};
